import { useEffect } from 'react';
import { CUSTOM_TAGS_OPTIONS } from '../../../../Shared/CustomTags';
import Select from '../../../../FormikFields/ComplexSelect/Select';
import { useSelector } from 'react-redux';

const CustomTagsSelector = ({
                              form,
                              values,
                              backendErrors,
                              disabled = false,
                            }) => {
  const { en: { tables } } = useSelector((state) => state.i18n);
  const dataKey = 'customTags';

  useEffect(() => {
    if (values.customTags.length === 0) {
      form.setFieldValue(dataKey, ['Other']);
    }
  }, [values.customTags]);

  return (
    <Select
      multiSelect
      disabled={disabled}
      customItemsPerPage={100}
      dataKey={dataKey}
      filterValue={values && values.customTags}
      columnData={{
        isFilterable: false,
        options: CUSTOM_TAGS_OPTIONS,
      }}
      onChange={(dataKey, listOfCheckedItem) => {
        if (listOfCheckedItem.length === 0) {
          form.setFieldValue(dataKey, ['Other']);
        } else {
          form.setFieldValue(dataKey, listOfCheckedItem);
        }
      }}
      label={tables.customTags}
      labelWidth={78}
      hasMenuPagination
      hasOptionalCheckBox={false}
      loading={false}
      error={backendErrors[dataKey]}
    />
  );
};

export default CustomTagsSelector;
